/* eslint-disable react/no-children-prop */
import useExpandable from 'Hooks/useExpandable';
import React from 'react';
import { useIntl } from 'react-intl';
import ExpandableWrapper from '../ExpandableWrapper';
import AddTagButton from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Tags/components/AddTagButton';
import { Wrapper } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Tags/styled';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { useSelector } from 'react-redux';

const TAB = 'general';
const ID = 'tags';

const Tags = () => {
  const intl = useIntl();
  const currentVuln = useSelector(selectVulnDetail);
  const isExpanded = useExpandable(TAB, ID, false, currentVuln?._id);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } id="tags" title={ intl.formatMessage({ id: 'manage.detail.tab.general.tags' }) } tab={ TAB }>
      <Wrapper>
        <AddTagButton />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Tags;
